import React, { forwardRef, useEffect, useState } from "react";

import Button from "@mui/material/Button";

import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    DEV_MOCK_FB_ACCESS_TOKEN,
    DEV_MOCK_FB_USER_ID,
    DEV_MODE,
} from "Constant/app/process";
import { useSelector } from "react-redux";

import SwalAlertComp from "../../SwalAlert";

const FaceBookSdk = forwardRef((props, ref) => {
    const language = useSelector((state) => state.languagesState.languages);
    const [fbReRequest, setFbReRequest] = useState(false);

    const onLoginClick = () => {
        if (props.setModalLoading) {
            props.setModalLoading(true);
        }
        if (props?.setLoaderStatus !== undefined) {
            props?.setLoaderStatus(true);
        }
        if (DEV_MODE) {
            setTimeout(() => {
                props.updatedData(
                    DEV_MOCK_FB_ACCESS_TOKEN,
                    DEV_MOCK_FB_USER_ID,
                );
                if (props.setModalLoading) {
                    props.setModalLoading(false);
                }
            }, 800);
            return;
        }
        if (props?.reRequest !== undefined && props?.reRequest === true) {
            window.FB.getLoginStatus((res) => {
                if (res?.status === "connected") {
                    setFbReRequest(true);
                } else {
                    setFbReRequest(false);
                }
            });
        }
        window.FB.login(
            function (responseFB) {
                if (responseFB.authResponse) {
                    let login_access_token =
                        responseFB.authResponse.accessToken;

                    props.updatedData(
                        login_access_token,
                        responseFB.authResponse?.userID,
                    );
                    if (props.setModalLoading) {
                        props.setModalLoading(false);
                    }
                } else {
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message:
                            "Error. No Pixel found! User cancelled login or did not fully authorize.",
                        icon: "error",
                    });
                    if (props.setModalLoading) {
                        props.setModalLoading(false);
                    }
                    if (props?.setLoaderStatus !== undefined) {
                        props?.setLoaderStatus(false);
                    }
                }
            },
            {
                ...(fbReRequest === true
                    ? {
                          scope: "pages_manage_ads,pages_read_engagement,pages_show_list,pages_manage_metadata,leads_retrieval,pages_show_list,pages_manage_metadata",
                          auth_type: "rerequest",
                      }
                    : {
                          scope: props.scope,
                      }),
                ...(props?.extras ? { extras: props.extras } : {}),
            },
        );
    };

    useEffect(() => {
        window.fbAsyncInit = () => {
            window.FB.init({
                appId: props.appId,
                autoLogAppEvents: true,
                xfbml: true,
                version: props.version,
            });
        };
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    }, []);

    return (
        <div>
            <Button
                onClick={onLoginClick}
                variant="outlined"
                color="primary"
                className="facebook-login-btn"
                ref={ref}
            >
                <>
                    <FontAwesomeIcon icon={faFacebookF} className="mr-2" />
                    {props.text}
                </>
            </Button>
        </div>
    );
});

export default FaceBookSdk;
